import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { Clock, BarChart, Rocket } from 'lucide-react';
import OnboardingLayout from './OnboardingLayout';
import './Onboarding.css';
import one from './one.png'
import two from './two.png'
import three from './three.png'
const ExploreTracks = () => {
  const tracks = [
    {
      title: "Full Stack Basics",
      description: "Master HTML, CSS, and JavaScript to build modern web applications from scratch.",
      tag: "Popular",
      tagIcon: "🔥",
      time: "12h",
      level: "Beginner",
      image: `${one}`
    },
    {
      title: "Data Science 101",
      description: "Learn to analyze complex data sets and visualize insights effectively using modern tools.",
      tag: "New",
      tagIcon: "✨",
      time: "8h",
      level: "Intermediate",
      image: `${two}`
    },
    {
      title: "Agile Leaders",
      description: "Lead high-performance teams using modern agile methodologies and frameworks.",
      tag: "Unique",
      tagIcon:"⚡",
      time: "10h",
      level: "Advanced",
      image: `${three}`
    }
  ];

  return (
    <OnboardingLayout hideLeft={true}>
      <div className="text-center m-5">
        <h2 className="fw-bold text-dark display-6">Explore Tracks</h2>
        <p className="text-muted mx-auto" style={{ maxWidth: '500px' }}>
          We've selected a few learning paths based on your interests. Pick one to get started or browse the full library later.
        </p>
      </div>

      <Row className="g-4 mb-5 px-md-3">
        {tracks.map((track, i) => (
          <Col lg={4} md={6} key={i}>
            <Card className="h-100 border-0 shadow-sm track-card rounded-4 overflow-hidden">
              <div className="position-relative overflow-hidden" style={{ height: '160px' }}>
                <Card.Img 
                  variant="top" 
                  src={track.image} 
                  className="h-100 w-100 object-fit-cover transition-transform"
                />
                {track.tag && (
                  <div className="position-absolute top-0 end-0 m-3 px-3 py-1 bg-white rounded-pill shadow-sm small fw-bold d-flex align-items-center">
                    <span className="me-1">{track.tagIcon}</span> {track.tag}
                  </div>
                )}
              </div>
              <Card.Body className="p-4 d-flex flex-column">
                <Card.Title className="fw-bold mb-2 h5">{track.title}</Card.Title>
                <Card.Text className="text-muted small mb-4 flex-grow-1" style={{ lineHeight: '1.6' }}>
                  {track.description}
                </Card.Text>
                <div className="d-flex align-items-center gap-3 text-muted" style={{ fontSize: '0.75rem' }}>
                  <span className="d-flex align-items-center gap-1">
                    <Clock size={14} /> {track.time}
                  </span>
                  <span className="opacity-25">•</span>
                  <span className="d-flex align-items-center gap-1">
                    <BarChart size={14} /> {track.level}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="text-center pb-3">
        <Button className="btn-ieee-primary rounded-pill px-5 py-3 fw-bold d-inline-flex align-items-center gap-2">
          Finish & Explore <Rocket size={18} />
        </Button>
      </div>
    </OnboardingLayout>
  );
};

export default ExploreTracks;
